import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cookie } from '@playcastdotio/Cookie';
import { Button } from '@playcastdotio/Shadcn';
import { useState } from 'react';

export const CookieManager = ({ children }) => {
  const { set, get } = cookie();
  const [show, setShow] = useState(get('cookie-consent') !== 'true');

  const handleClose = () => {
    set('cookie-consent', 'true');
    setShow(false);
  };

  return (
    <>
      {children}
      {show && (
        <div className='w-full md:w-3/6 lg:w-6/12 xl:w-[42rem] bg-gray-300 rounded-t-md fixed bottom-0 md:right-6 p-8 px-10'>
          <div className='flex flex-col space-y-6'>
            <div className='flex items-center'>
              <span className='font-bold text-2xl grow' role='img' aria-label='Playcast Uses Cookies'>
                Playcast Uses Cookies 🍪
              </span>
              <Button
                size='icon'
                className='bg-inherit hover:bg-inherit hover:text-red-500 focus:bg-inherit active:bg-inherit active:text-red-800'
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={faXmark} className='text-2xl' />
              </Button>
            </div>
            <p>
              We use cookies to ensure that we give you the best experience on the Playcast website and remote application. Some info about
              your use of our site is also shared with social media, advertising, and analytics partners who may combine it with other info
              you’ve provided or that they’ve collected from other uses of their services.{' '}
            </p>
            <div className='flex space-x-4'>
              <Button
                className='m-0 rounded-full bg-emerald-400 hover:bg-emerald-500 focus:bg-emerald-400 active:bg-emerald-500'
                onClick={handleClose}
              >
                Allow All
              </Button>
              <Button
                className='m-0 rounded-full bg-inherit border-2 border-emerald-600 text-emerald-600 hover:bg-inherit hover:text-emerald-700 hover:border-emerald-700 focus:bg-inherit active:bg-inherit'
                onClick={handleClose}
              >
                Necessary Only
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
